// extracted by mini-css-extract-plugin
export default {"inputLabel":"style-module--inputLabel--9424b"};